import * as React from 'react'
import { Colors } from '@kvika/audur-theme'

type Props = {
	loop?: boolean
	paused?: boolean
	style?: React.CSSProperties
	lottieClassName?: string
	height: number
	imageOffset: {
		x: number
		y: number
	}
	imagePath: string
}

const LottieCard = ({ loop = false, paused, style, height, imageOffset, imagePath, lottieClassName }: Props) => {
	const lottieRef = React.useRef<HTMLDivElement>(null)

	const [animation, setAnimation] = React.useState<any | null>(null)

	React.useEffect(() => {
		animation?.setSubframe(false)
	}, [animation])

	React.useEffect(() => {
		if (!animation) return
		if (paused) {
			animation?.pause()
		} else {
			animation?.play()
		}
	}, [animation, paused])

	React.useEffect(() => {
		let lottie: any

		// Import dynamically so it's only loaded on client
		import('lottie-web/build/player/lottie_light').then((mod) => {
			lottie = mod.default ?? mod

			if (lottieRef.current) {
				lottie.destroy()
				const anim = lottie.loadAnimation({
					container: lottieRef.current,
					renderer: 'svg',
					loop,
					autoplay: true,
					path: imagePath,
				})
				anim.setSubframe(false)
				setAnimation(anim)
			}
		})

		return () => {
			if (lottie) {
				lottie.destroy()
			}
		}
	}, [imagePath, loop])

	return (
		<div
			style={{
				marginBottom: imageOffset.y,
				backgroundColor: Colors.Transparent,
				...style,
			}}
			suppressHydrationWarning
		>
			<div style={{ height }} ref={lottieRef} className={lottieClassName} suppressHydrationWarning />
		</div>
	)
}

export default LottieCard
